import {Pipe, PipeTransform} from '@angular/core';
import {CompetitorResultsDetail, MeasurementPrecisionTypes, MeasurementTypes} from '@model';
import {RemoveLeadingZerosPipe} from "./remove-leading-zeros.pipe";
import {StringTimeToPrecisionPipe} from "./string-time-to-precision.pipe";

@Pipe({
  name: 'resultsTotalTime'
})
export class TotalTimePipe implements PipeTransform {

  constructor(private removeLeadingZerosPipe: RemoveLeadingZerosPipe, private stringTimeToPrecision: StringTimeToPrecisionPipe) {
  }
  transform(competitorResultsDetail: CompetitorResultsDetail | undefined, measurementType: MeasurementTypes | undefined, measurementPrecisionType: MeasurementPrecisionTypes | undefined, ignorePenalty: boolean = false): string {
    measurementPrecisionType = measurementPrecisionType ?? MeasurementPrecisionTypes.SECONDS;
    return this.removeLeadingZerosPipe.transform(this.stringTimeToPrecision.transform(TotalTimePipe.getTotalTime(competitorResultsDetail, measurementType, ignorePenalty).replace(".000", ""), measurementPrecisionType));
  }

  public static getTotalTime(competitorResultsDetail: CompetitorResultsDetail | undefined, measurementType: MeasurementTypes | undefined | MeasurementTypes.GUN_TIME_ONLY | MeasurementTypes.GUN_TIME_PRIMARY | MeasurementTypes.CHIP_TIME_PRIMARY | MeasurementTypes.EXTERNAL_IMPORT, ignorePenalty: boolean = false) {
    if (!competitorResultsDetail) {
      return '-';
    }
    if (measurementType === MeasurementTypes.CHIP_TIME_ONLY || measurementType === MeasurementTypes.CHIP_TIME_PRIMARY) {
      if (!ignorePenalty && competitorResultsDetail.tl_ch_tm_pen !== undefined && competitorResultsDetail.tl_ch_tm_pen !== null) {
        return competitorResultsDetail.tl_ch_tm_pen;
      } else if (competitorResultsDetail.tl_ch_tm !== undefined && competitorResultsDetail.tl_ch_tm !== null) {
        return competitorResultsDetail.tl_ch_tm;
      } else {
        return TotalTimePipe.getGunTotalTime(competitorResultsDetail, ignorePenalty);
      }
    } else {
      return TotalTimePipe.getGunTotalTime(competitorResultsDetail, ignorePenalty);
    }
  }

  public static getGunTotalTime(competitorResultsDetail: CompetitorResultsDetail, ignorePenalty: boolean = false) {
    if (!ignorePenalty && competitorResultsDetail.tl_tm_pen !== undefined && competitorResultsDetail.tl_tm_pen !== null) {
      return competitorResultsDetail.tl_tm_pen;
    } else if (competitorResultsDetail.tl_tm !== undefined && competitorResultsDetail.tl_tm !== null) {
      return competitorResultsDetail.tl_tm;
    } else {
      return '-';
    }
  }
}
